import { STATUS_LABEL } from './constants';
import { RequestEvent, RequestStatus } from './types';

export function formatDate(dateStr: string | null): string {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    // Date-only fields come back as plain `YYYY-MM-DD`, which `Date` reads as
    // UTC midnight. Without this the Puerto Rico offset renders them a day early.
    timeZone: 'UTC',
  });
}

export function formatDateTime(dateStr: string | null): string {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  const datePart = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const timePart = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  return `${datePart} at ${timePart.toLowerCase()}`;
}

export function daysWaiting(createdAt: string): number {
  const diffMs = Date.now() - new Date(createdAt).getTime();
  return Math.max(0, Math.floor(diffMs / 86400000));
}

/** True when `needed_by` has passed and the request is still open. */
export function isOverdue(neededBy: string | null, status: RequestStatus): boolean {
  if (!neededBy || status === 'COMPLETED' || status === 'REJECTED') return false;
  const today = new Date().toISOString().slice(0, 10);
  return neededBy < today;
}

export function describeEvent(event: RequestEvent): string {
  if (event.to_status && event.from_status) {
    return `${STATUS_LABEL[event.from_status]} → ${STATUS_LABEL[event.to_status]}`;
  }
  if (event.to_status) {
    return STATUS_LABEL[event.to_status];
  }
  return '';
}

export function callVolumeSummary(monthly: number | null, daily: number | null): string {
  const parts: string[] = [];
  if (monthly !== null) parts.push(`${monthly.toLocaleString()}/month`);
  if (daily !== null) parts.push(`${daily.toLocaleString()}/day`);
  return parts.length ? parts.join(' · ') : '—';
}
